<app-header [forceLightBackground]="true"></app-header>
<div class="admin-delegate-page">
  <div class="admin-delegate-page--layout">
    <app-admin-sidebar class="admin-delegate-page--sidebar"></app-admin-sidebar>
    <div class="admin-delegate-page--content">
      <app-page-header></app-page-header>
      <div class="delegate-container">
        <lib-manage-delegates
          tabStorageScope="cos-admin"
          [ownersOnly]="ownersOnly"
          [activeOwnerId]="activeDelegatedOwnerId"
          [scopeOptions]="platformAdminScopeOptions"
          (addDelegate)="onDelegateCreated()"
          (deleteDelegate)="onDelegateDeleted()"
          (withdrawOwner)="onAccessRevoked($event)"
          (switchOwner)="onSwitchOwner($event)"
          (requestOwner)="onRequestOwner($event)"
        ></lib-manage-delegates>
      </div>
    </div>
  </div>
</div>
